import RedfastService from './RedfastService';

export default RedfastService;
